import { Caring } from './Caring';
import { Categories, Ledger, Employee, Wood, WoodType, Products, UnitType, BrandNames, Size, GST } from './CreateProductType';

export interface MasterState {
  categories: Categories[];
  employees: Employee[];
  ledgers: Ledger[];
  products: Products[];
  unittypes: UnitType[];
  sizes: Size[];
  brandnames: BrandNames[];
  gsts: GST[];
  loading: boolean;
  loaded: boolean;
}

const initialState: MasterState = {
  categories: [],
  employees: [],
  ledgers: [],
  products: [],
  unittypes: [],
  sizes: [],
  brandnames: [],
  gsts: [],
  loading: false,
  loaded: false
};

export { initialState };